/**
 * NOK payout amounts from a prize pool and a percentageBp ladder.
 *
 * Rounding contract — same as `PayoutEditor` on the admin floor view and
 * the legacy `/s/:key/poker`: each position rounds DOWN to nearest 100 kr;
 * any residual kroner (from rounding loss) goes to 1st place. This keeps
 * the player's number byte-identical to what the floor announces.
 */
export type PayoutSlot = { position: number; percentageBp: number }

export const payoutAmountsNOK = (
  payouts: ReadonlyArray<PayoutSlot>,
  prizePool: number
): Map<number, number> => {
  if (!prizePool || prizePool <= 0) return new Map()
  const sorted = [...payouts].sort((a, b) => a.position - b.position)
  const rounded = sorted.map(
    (p) => Math.floor(((p.percentageBp / 10000) * prizePool) / 100) * 100
  )
  const residual = prizePool - rounded.reduce((acc, n) => acc + n, 0)
  const out = new Map<number, number>()
  sorted.forEach((p, i) => {
    out.set(p.position, i === 0 ? rounded[i] + residual : rounded[i])
  })
  return out
}
